import Vue from 'vue'
import App from './App.vue'
import Meta from 'vue-meta'
import VueAnalytics from 'vue-analytics'
import VueI18n from 'vue-i18n'
import router from './router'
import messages from './lang/messages'

Vue.use(VueI18n)

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  id: ['UA-11794363-31', 'UA-141544019-1'],
  router
})
Vue.$ga.set({ anonymizeIp: true })

Vue.use(Meta)

let defaultLocale = 'it'
var locale = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');

const i18n = new VueI18n({
  locale: (locale.trim().length && locale != "/") ? locale : defaultLocale ,
  messages, // set locale messages
})
new Vue({
  router,
  render: h => h(App),
  i18n
}).$mount('#app')
